<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro de Departamento">
    <form ref="form" @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-8">
          <label for="nome">Departamento</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <input v-model="registro.nome" type="text" class="form-control form-input-component" required />
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label>Especialidades</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <div class="input-group input-focus">
            <a-auto-complete v-model:value="selecionarNome" style="width: 200px" @search="pesquisarEspecialidade" class="form-control border-left-0">
              <template v-slot:dataSource>
                <a-select-option v-for="item in especialidadesFiltro" :key="item.nome" @click="onSelect(item)">
                  {{ item.nome }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </div>
        <div class="col-md-4">
          <label></label>
          <br />
          <button type="button" class="btn btn-primary" @click="selecionarItem">Incluir</button>
        </div>
      </div>

      <br />
      <div class="row" v-show="itensSelecionados.length > 0">
        <div class="col-md-8">
          <a-table :dataSource="itensSelecionados" :columns="columns">
            <template #action="{ record }">
              <a title="Opções" @click="removerEspecialidade(record)"><i class="fas fa-trash icon-trash"></i></a>
              &nbsp;
            </template>
          </a-table>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label for="status">Status</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>

          <div class="input-group input-focus">
            <select v-model="registro.situacao" class="form-select form-input-component" required>
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { createDepartamento, getDepartamentoById } from '@/components/service/departamentoService';
import { getEspecialidades } from '@/components/service/especilidadeService';
import _ from 'lodash';
export default {
  name: 'FormManterDepartamento',
  setup() {
    return {};
  },
  data() {
    return {
      especialidades: [],
      especialidadesFiltro: [],
      selecionarNome: '',
      nomeSelecionado: null,
      idSelecionado: null,
      itensSelecionados: [],
      registro: {},
      columns: [
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },

        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      if (!this.$refs.form.checkValidity()) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else if (this.itensSelecionados.length == 0) {
        openNotification(typesNotification.warning, 'Você deve incluir pelo menos uma especialidade para cadastrar o departamento!');
      } else {
        let departamentoPost = { ...this.registro };
        departamentoPost.especialidades = this.itensSelecionados;
        await createDepartamento(departamentoPost).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.departamentoPost = {};
          this.itensSelecionados = [];
          this.submitted = true;
          this.registro = {};
        });
      }
    },
    async getEspecialidades() {
      await getEspecialidades().then((esp) => {
        let especialidadesTemp = [];
        esp.data.forEach((e) => {
          especialidadesTemp.push({
            id: e.especialidade.id,
            nome: e.especialidade.nome,
            situacao: 'ATIVO',
          });
        });
        this.especialidades = _.orderBy(especialidadesTemp, 'nome', 'asc');
      });
    },
    onSelect(value) {
      this.selecionar = value;
      this.selecionarNome = value.nome;
    },
    selecionarItem() {
      if (this.selecionar !== null && this.selecionar !== undefined) {
        let especialidadeSelecionada = { ...this.selecionar };
        let jaContem = this.itensSelecionados.filter(function (item) {
          return item.nome === especialidadeSelecionada.nome;
        });
        if (jaContem.length > 0) {
          openNotification(typesNotification.warning, 'A especialidade ' + especialidadeSelecionada.nome + ' já está na lista!');
        } else {
          this.itensSelecionados.push(this.selecionar);
          this.selecionar = null;
          this.selecionarNome = null;
          this.especialidadesFiltro = [];
        }
      } else {
        openNotification(typesNotification.warning, 'Você deve selecionar uma especialidade para adicionar na lista!');
      }
    },
    pesquisarEspecialidade(value) {
      if (value.length >= 2) {
        let especialidadesTemp = [...this.especialidades];
        this.especialidadesFiltro = especialidadesTemp.filter((e) => e.nome.toUpperCase().includes(value.toUpperCase()));
      } else {
        this.especialidadesFiltro = [];
      }
    },
    removerEspecialidade(record) {
      const index = this.itensSelecionados.indexOf(record);
      if (index > -1) {
        this.itensSelecionados.splice(index, 1);
      }
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregarDepartamento() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getDepartamentoById(idUrl);
        this.registro = { ...res.data, id: idUrl };
        if (this.registro.especialidades) {
          this.itensSelecionados = [...this.registro.especialidades];
        }
      }
    },
  },
  async created() {
    await this.getEspecialidades();
    this.carregarDepartamento();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
